<template>
  <router-view />
</template>

<style lang="less">
@import url('@/assets/style.less');
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  --main-c: #1f5dfe;
}
* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}
a {
  text-decoration: none;
}
.row_b {
  display: flex;
  justify-content: space-between;
}

.row_a {
  display: flex;
  align-items: center;
}

ul {
  list-style: none;
}

@font-face {
  font-family: "iconfont"; /* Project id 4881218 */
  src: url('//at.alicdn.com/t/c/font_4881218_dw4xb79ammb.woff2?t=1757591248956') format('woff2'),
       url('//at.alicdn.com/t/c/font_4881218_dw4xb79ammb.woff?t=1757591248956') format('woff'),
       url('//at.alicdn.com/t/c/font_4881218_dw4xb79ammb.ttf?t=1757591248956') format('truetype');
}

.iconfont {
  font-family: "iconfont" !important;
  font-size: 16px;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.icon-diandan:before {
  content: "\e6c3";
}

.icon-shouyinji:before {
  content: "\e615";
}

.icon-shanchuxian:before {
  content: "\e6ff";
}

.icon-zitixieti:before {
  content: "\ec85";
}

.icon-lianjie:before {
  content: "\e6a5";
}

.icon-xiahuaxian:before {
  content: "\e61c";
}

.icon-shangchuantupian:before {
  content: "\e61e";
}

.icon-dingdan:before {
  content: "\e645";
}

.icon-dailishang:before {
  content: "\e628";
}

.icon-dingdan1:before {
  content: "\e60c";
}

.icon-tongzhizhongxin:before {
  content: "\eb43";
}

.icon-shezhi:before {
  content: "\e851";
}

.icon-lunbotuguanli:before {
  content: "\e642";
}

.icon-shouhoufuwu:before {
  content: "\e691";
}

.icon-yonghuguanli_huaban:before {
  content: "\e62d";
}

.icon-shouye:before {
  content: "\e6df";
}

</style>
